import { createDemoAdapter } from "./demo-adapter";
import { createHttpAdapter } from "./http-adapter";
import { resolveRuntimeConfig } from "./runtime";

export const runtimeConfig = resolveRuntimeConfig(import.meta.env);

export const mathosApi =
  runtimeConfig.apiMode === "demo"
    ? createDemoAdapter({
        dataControlsEnabled: import.meta.env.MODE === "e2e",
      })
    : createHttpAdapter(runtimeConfig.apiBaseUrl, {
        allowNonReleaseSourceDrafts:
          runtimeConfig.allowsNonReleaseSourceDrafts,
      });
